module.exports = __webpack_public_path__ + "img/header_middle_bg.7646c11a.png";